import React from 'react'
import AccordionSuggestion from 'ui-shared/accordions/AccordionSuggestion'
import DefaultTimeBeforeAfterHint from './DefaultTimeBeforeAfterHint'
import KAccordion from 'ui-shared/accordions/KAccordion'
import ContentToggler from 'ui-shared/ContentToggler'
import BeforeAfterHintArrayInput from './BeforeAfterHintArrayInput'

type Props = {
  accordionText: string[]
}

const BeforeAfterHintForm: React.FC<Props> = ({ accordionText, ...props }) => {
  return (
    <KAccordion accordionTitle="Time">
      <ContentToggler
        {...props}
        source="showTimeBeforeAfterHint"
        label="form.fields.showTimeHint"
      >
        <BeforeAfterHintArrayInput />
        <DefaultTimeBeforeAfterHint />
      </ContentToggler>
      <AccordionSuggestion
        accordionTitle="form.fields.howItWorks"
        accordionText={accordionText}
      />
    </KAccordion>
  )
}

export default BeforeAfterHintForm
